import { translate } from 'react-i18next';
import { compose, hoistStatics, lifecycle, withState, withHandlers, withPropsOnChange } from 'recompose';
import Search from './Search';

const changeValue = props => (value) => {
  props.setValue(value);
};

const search = props => ({ target }) => {
  const { timer, setTimer } = props;
  clearTimeout(timer);
  const { value } = target;
  changeValue(props)(value);
  const newTimer = setTimeout(() => { props.callbackToSetSearch(value); }, 500);
  setTimer(newTimer);
};


const clearValue = (props) => {
  props.setValue('');
};

const enhance = compose(
  withState('isLoading', 'setIsLoading', true),
  withState('timer', 'setTimer', null),
  withState('value', 'setValue', ''),
  translate('portal'),
  lifecycle({
    async componentDidMount() {
      this.props.setIsLoading(false);
    },
  }),
  withPropsOnChange(['update', 'changeSearchCallback'], (props) => {
    if (props.changeSearchCallback !== undefined) {
      changeValue(props)(props.defaultValue || '');
    } else {
      clearValue(props);
    }
  }),
  withHandlers({
    search,
  }),
);

export default hoistStatics(enhance)(Search);



// WEBPACK FOOTER //
// ./src/components/searchField/index.js